import type { JSX } from "react";
import Svg, { Path, Rect } from "react-native-svg";

import {
  DEFAULT_BRAND,
  DEFAULT_MUTED,
  frame,
  type IconProps,
} from "./icon-props";

// Product UI icons — chrome, controls, affordances. Phosphor-shaped
// with the same 1.7px stroke convention as the credential set.

export function MicrophoneIcon({
  size = 24,
  color = DEFAULT_BRAND,
  strokeWidth = 1.7,
}: IconProps): JSX.Element {
  return (
    <Svg {...frame({ size })} fill="none">
      <Rect
        x={9}
        y={3}
        width={6}
        height={11}
        rx={3}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6 11a6 6 0 0 0 12 0M12 17v3"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function SparkleIcon({
  size = 24,
  color = DEFAULT_BRAND,
  strokeWidth = 1.7,
}: IconProps): JSX.Element {
  return (
    <Svg {...frame({ size })} fill="none">
      <Path
        d="M12 4l1.7 4.6 4.6 1.7-4.6 1.7L12 16.6l-1.7-4.6-4.6-1.7 4.6-1.7z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M19 4v3M17.5 5.5h3"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function ChevronRightIcon({
  size = 24,
  color = DEFAULT_MUTED,
  strokeWidth = 1.7,
}: IconProps): JSX.Element {
  return (
    <Svg {...frame({ size })} fill="none">
      <Path
        d="M9 5l7 7-7 7"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function SearchIcon({
  size = 24,
  color = DEFAULT_MUTED,
  strokeWidth = 1.7,
}: IconProps): JSX.Element {
  return (
    <Svg {...frame({ size })} fill="none">
      <Path
        d="M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM16 16l4 4"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function CloseIcon({
  size = 24,
  color = DEFAULT_MUTED,
  strokeWidth = 1.7,
}: IconProps): JSX.Element {
  return (
    <Svg {...frame({ size })} fill="none">
      <Path
        d="M6 6l12 12M18 6L6 18"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function ShieldIcon({
  size = 24,
  color = DEFAULT_BRAND,
  strokeWidth = 1.7,
}: IconProps): JSX.Element {
  return (
    <Svg {...frame({ size })} fill="none">
      <Path
        d="M12 3l7 3v6c0 4-3 7-7 9-4-2-7-5-7-9V6z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
